export const changeSavedAnalysesReducer = (state = [], action) => {
  switch (action.type) {
    case "CHANGE_SAVED_ANALYSES":
      return action.payload.savedAnalyses;
    default:
      return state;
  }
};
